/**
 * Checks if being rendered on server side or not.
 * @returns
 */
export function isSsr() {
	return typeof window === 'undefined';
}
